module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('sidebar', {
    attrs: {
      "isSideBarOpen": _vm.isSideBarOpen
    },
    on: {
      "close": _vm.closeSidebar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    class: {
      overlay: _vm.isSideBarOpen
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('svg', {
    staticClass: "ham-icon",
    attrs: {
      "height": "32px",
      "width": "32px"
    },
    on: {
      "click": _vm.openSidebar
    }
  }, [_c('path', {
    attrs: {
      "d": "M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,\n          8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,\n          0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,\n          2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"
    }
  })]), _vm._v("\n      Awesome IPL\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container-fixed"
  }, [_c('router-view')], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e75bbc38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 403
// module chunks = 1